import React from "react";
import { Card, Col, Row } from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const CounterWidget = ({
  category,
  title,
  icon,
  iconColor = "primary",
  onClick,
}) => {
  return (
    <Card
      className="counter-widget-card border-0"
      onClick={onClick}
      style={{ cursor: onClick ? "pointer" : "default" }}
    >
      <Card.Body className="p-3">
        <Row className="align-items-center">

          {/* ICON */}
          <Col xs="auto">
            <div className={`counter-icon counter-icon-${iconColor}`}>
              <FontAwesomeIcon icon={icon} />
            </div>
          </Col>

          {/* CONTENT */}
          <Col className="ps-2">
            <div className="counter-category">
              {category}
            </div>

            <div className="counter-value">
              {title ?? 0}
            </div>
          </Col>

        </Row>
      </Card.Body>
    </Card>
  );
};

export default CounterWidget;